import { useEffect, useState } from 'react';

/**
 * DIE TELEFON-WEICHE (Auftrag CRM-106, ÄA-63).
 *
 * Ob die Oberfläche auf dem Telefon steht, entscheidet EINE Stelle. Die
 * Stilregeln schalten an derselben Grenze (`@media (max-width: 600px)`, wie
 * die Regeln aus CRM-105);
 * wer Aufbau statt Aussehen wechselt — Kopf mit Schublade, Karten statt
 * Zeitachse, Lesen statt Bearbeiten —, fragt diesen Hook.
 *
 * Es ist reine Darstellung. Rechte bleiben unberührt: Was auf dem Telefon
 * ausgeblendet ist, verweigert nicht der Knopf, sondern weiter der Server.
 *
 * Ohne `matchMedia` (jsdom in den Prüfungen) gilt der breite Schirm — so
 * sehen alle bestehenden Prüfungen die Maske wie bisher.
 */
export const TELEFON = '(max-width: 600px)';

function passt(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(TELEFON).matches
    : false;
}

export function useTelefon(): boolean {
  const [telefon, setzeTelefon] = useState(passt);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const abfrage = window.matchMedia(TELEFON);
    const beiWechsel = (): void => setzeTelefon(abfrage.matches);
    beiWechsel();
    abfrage.addEventListener('change', beiWechsel);
    return () => abfrage.removeEventListener('change', beiWechsel);
  }, []);
  return telefon;
}
